import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import {
  CreateSKPRBAC,
  DuplicateSKPRBAC,
  ViewDetailSKPRBAC,
  SKPListSourcingRBAC,
  SKPListCampaignRBAC,
  SKPListFinanceRBAC,
  SKPFinanceDetailsRBAC,
  SKPCampaignDetailsRBAC,
  SyaratKetentuanRBAC,
  InternalSKPListRBAC,
  CreateInternalSKPRBAC,
  InternalSKPDetailRBAC,
} from './rbac'

const Sourcing = lazy(() => import('../pages/Sourcing'))
const SourcingDetails = lazy(() => import('../pages/SourcingDetails'))
const Finance = lazy(() => import('../pages/Finance'))
const FinanceDetails = lazy(() => import('../pages/FinanceDetails'))
const Campaign = lazy(() => import('../pages/Campaign'))
const CampaignDetails = lazy(() => import('../pages/CampaignDetails'))
const TermsAndCondition = lazy(() => import('../pages/SyaratKetentuan'))
const Internal = lazy(() => import('../pages/Internal'))
const InternalDetails = lazy(() => import('../pages/InternalDetails'))
const AddEditDuplicateInternalSKP = lazy(() => import('../pages/AddEditDuplicateInternalSKP'))
const AddEditSKPNewFlow = lazy(() => import('../pages/AddEditSKPNewFlow'))

const SourcingRouter: RouterFeatureInterface<'SourcingSKP', '/dashboard/skp/sourcing'> = {
  name: 'SourcingSKP',
  Component: Sourcing,
  path: '/dashboard/skp/sourcing',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: SKPListSourcingRBAC.pageID,
  isDashboard: true,
}

const TermsAndConditionRouter: RouterFeatureInterface<
  'TermsAndConditionSKP',
  '/dashboard/skp/terms-and-conditions'
> = {
  name: 'TermsAndConditionSKP',
  Component: TermsAndCondition,
  path: '/dashboard/skp/terms-and-conditions',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: SyaratKetentuanRBAC.pageID,
  isDashboard: true,
}

const SourcingDetailsRouter: RouterFeatureInterface<
  'SourcingDetailsSKP',
  '/dashboard/skp/sourcing/details/:id'
> = {
  name: 'SourcingDetailsSKP',
  Component: SourcingDetails,
  path: '/dashboard/skp/sourcing/details/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ViewDetailSKPRBAC.pageID,
}

export const FinanceRouter: RouterFeatureInterface<'FinanceSKP', '/dashboard/skp/finance'> = {
  name: 'FinanceSKP',
  Component: Finance,
  path: '/dashboard/skp/finance',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SKPListFinanceRBAC.pageID,
}

const FinanceDetailsRouter: RouterFeatureInterface<
  'FinanceSKPDetails',
  '/dashboard/skp/finance/details/:id'
> = {
  name: 'FinanceSKPDetails',
  Component: FinanceDetails,
  path: '/dashboard/skp/finance/details/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: SKPFinanceDetailsRBAC.pageID,
  isDashboard: true,
}

export const CampaignRouter: RouterFeatureInterface<'CampaignSKP', '/dashboard/skp/campaign'> = {
  name: 'CampaignSKP',
  Component: Campaign,
  path: '/dashboard/skp/campaign',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SKPListCampaignRBAC.pageID,
}

const CampaignDetailsRouter: RouterFeatureInterface<
  'CampaignDetailsSKP',
  '/dashboard/skp/campaign/details/:id'
> = {
  name: 'CampaignDetailsSKP',
  Component: CampaignDetails,
  path: '/dashboard/skp/campaign/details/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: SKPCampaignDetailsRBAC.pageID,
}

export const InternalSKPRouter: RouterFeatureInterface<
  'InternalSKP',
  '/dashboard/skp/internal-skp'
> = {
  name: 'InternalSKP',
  Component: Internal,
  path: '/dashboard/skp/internal-skp',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: InternalSKPListRBAC.pageID,
  isDashboard: true,
}

export const InternalSKPDetailsRouter: RouterFeatureInterface<
  'InternalDetailsSKP',
  '/dashboard/skp/internal-skp/details/:id'
> = {
  name: 'InternalDetailsSKP',
  Component: InternalDetails,
  path: '/dashboard/skp/internal-skp/details/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: InternalSKPDetailRBAC.pageID,
  isDashboard: true,
}

export const AddInternalSKPRouter: RouterFeatureInterface<
  'AddInternalSKP',
  '/dashboard/skp/add-internal-skp'
> = {
  name: 'AddInternalSKP',
  Component: AddEditDuplicateInternalSKP,
  path: '/dashboard/skp/add-internal-skp',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: CreateInternalSKPRBAC.pageID,
  isDashboard: true,
}

export const EditInternalSKPRouter: RouterFeatureInterface<
  'EditInternalSKP',
  '/dashboard/skp/edit-internal-skp/:id'
> = {
  name: 'EditInternalSKP',
  Component: AddEditDuplicateInternalSKP,
  path: '/dashboard/skp/edit-internal-skp/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: CreateInternalSKPRBAC.pageID,
  isDashboard: true,
}

export const DuplicateInternalSKPRouter: RouterFeatureInterface<
  'DuplicateInternalSKP',
  '/dashboard/skp/duplicate-internal-skp/:id'
> = {
  name: 'DuplicateInternalSKP',
  Component: AddEditDuplicateInternalSKP,
  path: '/dashboard/skp/duplicate-internal-skp/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: CreateInternalSKPRBAC.pageID,
  isDashboard: true,
}

export const CreateSKPNewFlowRouter: RouterFeatureInterface<
  'CreateSKPNewFlow',
  '/dashboard/skp/create-skp'
> = {
  name: 'CreateSKPNewFlow',
  Component: AddEditSKPNewFlow,
  path: '/dashboard/skp/create-skp',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: CreateSKPRBAC.pageID,
  isDashboard: true,
}

export const DuplicateSKPNewFlowRouter: RouterFeatureInterface<
  'DuplicateSKPNewFlow',
  '/dashboard/skp/duplicate-skp/:duplicateId'
> = {
  name: 'DuplicateSKPNewFlow',
  Component: AddEditSKPNewFlow,
  path: '/dashboard/skp/duplicate-skp/:duplicateId',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: DuplicateSKPRBAC.pageID,
  isDashboard: true,
}

const SKPRouter = [
  SourcingRouter,
  SourcingDetailsRouter,
  FinanceRouter,
  FinanceDetailsRouter,
  CampaignRouter,
  CampaignDetailsRouter,
  InternalSKPRouter,
  InternalSKPDetailsRouter,
  AddInternalSKPRouter,
  EditInternalSKPRouter,
  DuplicateInternalSKPRouter,
  TermsAndConditionRouter,
  CreateSKPNewFlowRouter,
  DuplicateSKPNewFlowRouter,
]

export const SKPRouterDetail = generateRouterDetail(SKPRouter)

export default SKPRouter
